import { useSyncExternalStore } from "react";

// Set while the NotFound page is mounted so the global <AutoSEO /> stops
// emitting a canonical for an address that does not exist.
let active = 0;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export const markNotFound = () => {
  active += 1;
  emit();
  return () => {
    active -= 1;
    emit();
  };
};

export const useIsNotFound = () =>
  useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => active > 0,
    () => false,
  );
